import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PrivateRoute from './components/utils/routes/privateRoute'
import Home from './pages/Home/home.js';
import Dashboard from './pages/Dashboard/dashboard.js';
import GaragesPage from './pages/Garages/garagesPage';
import ExtraVirtualRemotesPage from './pages/ExtraVirtualRemotes/extraVirtualRemotesPage';

export default function Routes()
{
    return (
        <Switch>
            <Route exact path="/" component={ Home } />
            <PrivateRoute exact path="/dashboard" component={ Dashboard } />
            <PrivateRoute exact path="/garages" component={ GaragesPage } />
            <PrivateRoute exact path="/extra-virtual-remotes" component={ ExtraVirtualRemotesPage } />
        </Switch>
    )
}